import { Sidebar, Skeleton, SkeletonText } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

const SAVED_VIEW_SKELETON_IDS = [
  'saved-view-skeleton-1',
  'saved-view-skeleton-2',
  'saved-view-skeleton-3',
  'saved-view-skeleton-4',
  'saved-view-skeleton-5',
]

/** Loading placeholder for the SavedViewsSection list. */
export function SavedViewsSectionSkeleton(): JSX.Element {
  return (
    <Sidebar.List aria-label="Views">
      {SAVED_VIEW_SKELETON_IDS.map((skeletonId) => (
        <Sidebar.ListItem key={skeletonId}>
          <Sidebar.ButtonSkeleton prefix={<Skeleton width={20} height={20} />}>
            <SkeletonText lines={1} width={96} />
          </Sidebar.ButtonSkeleton>
        </Sidebar.ListItem>
      ))}
    </Sidebar.List>
  )
}
